export default "__VITE_ASSET__6c3afa45__"